import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';

import { LayoutService } from './services/layout.service';
import { PlatformService } from './services/platform.service';
import { SplashScreenService } from './services/splash-screen.service';

/**
 * Eagerly instantiates the layout services. All three do their work in their constructor — hiding the
 * splash screen, tagging the body, reacting to the desktop breakpoint — so none of them can wait for a
 * first injection from a component.
 */
export function provideLayout(): (Provider | EnvironmentProviders)[] {
  return [
    provideEnvironmentInitializer(() => inject(SplashScreenService)),
    provideEnvironmentInitializer(() => inject(LayoutService)),
    provideEnvironmentInitializer(() => inject(PlatformService)),
  ];
}
